<template>
    <div>
        <b-card class="standardpage pt-0">
            <div v-if="selectedComponent == null">
                <b-card-header class="px-0">
                    <b-navbar toggleable="lg" type="light" variant="light">
                        <b-navbar-brand href="#">{{ reports.title }}</b-navbar-brand>

                        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                        <b-collapse id="nav-collapse" is-nav>
                            <b-navbar-nav>
                                <b-nav-item href="#" @click="load()">Home</b-nav-item>
                                <!-- <b-nav-item href="#" disabled>Draft</b-nav-item>
                                <b-nav-item href="#" disabled>Published</b-nav-item> -->
                            </b-navbar-nav>
                        </b-collapse>

                        <b-navbar-nav class="ml-auto">
                            <b-nav-form>
                                <!-- <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
              <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button> -->

                                <b-col cols="12" class="mt-2 mt-sm-0">
                                    <div class="card-header-actions">
                                        <div style="display: flex; justify-content: space-between">
                                            <b-form-group size="sm" class="mb-0">
                                                <b-input-group style="width:300px;">
                                                    <b-form-input size="sm" v-model="fuzzy"
                                                        placeholder="Find a report"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" style="width: auto; padding: 0.25rem 0.6rem"
                                                            variant="outline-primary" :disabled="!fuzzy"
                                                            @click="fuzzy = ''">
                                                            <i v-if="fuzzy" class="fa fa-remove"></i>
                                                            <i v-if="!fuzzy" class="fa fa-search"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </div>
                                    </div>
                                </b-col>

                            </b-nav-form>
                        </b-navbar-nav>
                    </b-navbar>
                    <!-- <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="reports.icon" class="mr-1"></i>
                        <span>{{ reports.title }}</span>
                    </b-col>
                 
                </b-row> -->
                </b-card-header>

                <!-- {{ reports.categories }}<br />
                {{ reports.items }} -->
                <!-- {{ reports.items.filter(r => r.favourite == 1) }} -->

                <b-row class="mb-4 mx-0 p-4 bg-light">
                    <b-col>
                        <div id="favourites"> <b-button v-b-toggle.collapse-99 variant="secondary"
                                style="border-radius:100%;"><i :class="collapsed ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" 
                                    aria-hidden="false"></i></b-button><span class="ml-2 strong" style="font-size:18px;"
                                v-b-toggle.collapse-99>Favourites</span></div>
                        <b-tooltip target="favourites" triggers="hover" placement="right" html>To add a report to your
                            favourites, find a report listed below and toggle the <i class="fa fa-star-o mx-1"></i> icon
                            to add or remove it from the
                            favourites.</b-tooltip>
                        <b-collapse id="collapse-99" class="mt-2 px-5" visible>

                            <div class="row">
                                <div v-for="(report, index) in reports.items.filter(r => r.favourite == 1)" :key="index"
                                    class="col-4 mb-1">
                                    <b-list-group-item button :pressed="selectedComponent == 'Report'">
                                        <b-row align-v="top" no-gutters>
                                            <b-col cols="auto"> <i @click="toggle_favourite(report)"
                                                    class="mr-3 text-primary"
                                                    :class="report.favourite == 1 ? 'fa fa-star' : 'fa fa-star-o'"></i></b-col>
                                            <b-col @click="
                                                runreport({
                                                    label: report.name,
                                                    id: report.component,
                                                }, 'Report1')
                                                ">
                                                <span class="h5" style="font-size:16px">{{ report.name }}</span>
                                                <div v-if="showdescriptions">
                                                    <span
                                                        style="font-size:12px; font-style: italic; font-weight: normal;">{{
                                                            report.name_description }}</span>
                                                </div>
                                            </b-col>
                                            <b-col @click="
                                                runreport({
                                                    label: report.name,
                                                    id: report.component,
                                                }, 'Report1')
                                                " cols="auto">
                                                <i class="ml-2 fa fa-leanpub text-primary text-right">
                                                </i>
                                            </b-col>
                                        </b-row>
                                    </b-list-group-item>
                                </div>
                            </div>

                        </b-collapse>
                    </b-col>
                </b-row>

                <b-row class="px-4">
                    <b-col>
                        <h5>All Reports</h5>
                    </b-col>
                    <b-col cols="auto" class="text-right">
                        <span>Show descriptions</span>
                        <b-form-checkbox v-model="showdescriptions" switch size="lg"></b-form-checkbox>
                    </b-col>
                </b-row>

                <b-row class="px-3">
                    <b-col cols="12" class="divider my-2"></b-col>

                </b-row>


                <div v-for="(category, cindex) in reports.categories.map(t => t.category)" :key="cindex" class="mb-3">

                    <b-row class="mt-3 mb-4 mx-0 px-4 ">
                        <b-col>
                            <b-row no-gutters>
                                <b-col cols="auto">
                                    <b-button v-b-toggle="'collapse-' + cindex" variant="secondary"
                                        style="border-radius:100%;"><i class="fa fa-chevron-down"
                                            aria-hidden="false"></i></b-button>

                                </b-col>
                                <b-col>
                                    <span class="ml-2 strong" style="font-size:18px;"
                                        v-b-toggle="'collapse-' + cindex">{{ category }}</span>
                                    <p v-if="showdescriptions" class="card-text pb-2 ml-2">{{
                                        reports.categories.find(o => o.category == category).category_description}}</p>
                                </b-col>
                            </b-row>


                            <b-collapse :id="'collapse-' + cindex" visible class="mt-2 px-5">
                                <div class="row">
                                    <div v-for="(report, index) in reports.items.filter(r => r.category == category)"
                                        :key="index" class="col-4 mb-1">
                                        <b-list-group-item button :pressed="selectedComponent == 'Report'">
                                            <b-row align-v="top" no-gutters>
                                                <!-- <b-col cols="auto" class="mr-2"></b-col> -->
                                                <b-col cols="auto">
                                                    <i :id="category + '_' + index" @click="toggle_favourite(report)"
                                                        class="mr-3 text-primary"
                                                        :class="report.favourite == 1 ? 'fa fa-star' : 'fa fa-star-o'"></i>
                                                    <b-tooltip :target="category + '_' + index" triggers="hover"
                                                        placement="left">Click
                                                        to toggle this report as a favourite.</b-tooltip>
                                                </b-col>
                                                <b-col @click="
                                                    runreport({
                                                        label: report.name,
                                                        id: report.component,
                                                    }, 'Report1')
                                                    ">
                                                    <span class="h5" style="font-size:16px">{{ report.name }}</span>
                                                    <div v-if="showdescriptions">
                                                        <span
                                                            style="font-size:12px; font-style: italic; font-weight: normal;">{{
                                                                report.name_description
                                                            }}</span>
                                                    </div>
                                                </b-col>
                                                <b-col @click="
                                                    runreport({
                                                        label: report.name,
                                                        id: report.component,
                                                    }, 'Report1')
                                                    " cols="auto">
                                                    <i class="ml-2 fa fa-leanpub text-primary text-right">
                                                    </i></b-col>
                                            </b-row>
                                        </b-list-group-item>
                                    </div>
                                </div>
                            </b-collapse>
                        </b-col>
                    </b-row>
                </div>

            </div>

            <div>
                <component :is="selectedComponent" :search="search" :showback="true"
                    @discard="selectedComponent = null" />
            </div>

            <b-card-footer v-if="selectedComponent" class="mt-2 ml-1">
                <b-row>
                    <b-col class="nopadding text-center">
                        <b-button squared size="sm" variant="outline-primary" @click="selectedComponent = null">
                            <i class="fa fa-bars mr-2"></i>All Reports
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-footer>
        </b-card>

    </div>
</template>


<script>
import gql from "graphql-tag";

function dynamicSort(property) {
    var sortOrder = 1;

    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a, b) {
        if (sortOrder == -1) {
            return b[property].localeCompare(a[property]);
        } else {
            return a[property].localeCompare(b[property]);
        }
    };
}


export default {
    name: "AllReports",
    data() {
        return {
            selectedComponent: null,
            showdescriptions: false,
            fuzzy: null,
            reports:
            {
                title: "Reports",
                icon: "fa fa-leanpub",
                debounce: 500,
                items: [],
                categories: []
            }
        };
    },
    async mounted() {
        await this.load()
    },
    watch: {
        async fuzzy() {
            await this.load()
        }
    },
    methods: {
        async load() {

            let variables = {
                // name: "allreports",
                fuzzy: this.fuzzy ? this.fuzzy : null,
            };
            console.log("variables", variables);

            this.busy = true;

            try {
                const response = await this.$apollo.query({
                    query: gql`
                    query setup_reports_all($fuzzy: String) {
                        setup_reports_all(fuzzy: $fuzzy) {
                            category
                            category_description
                            name
                            name_description
                            favourite
                            component
                        }
                    }
                    `,
                    variables,
                });

                this.reports.categories = []
                for (var i = 0; i < response.data.setup_reports_all.length; i++) {
                    let item = response.data.setup_reports_all[i];
                    if (item.category != 'Favourites') {
                        let found = this.reports.categories.find(o => o.category == item.category);
                        if (!found) {
                            this.reports.categories.push({ category: item.category, category_description: item.category_description });
                        }
                    }

                }
                this.reports.items = response.data.setup_reports_all

            } catch (error) {
                console.log(error);
            }

            this.busy = false;
        },
        runreport(e, c) {
            console.log("run", e);
            if (c) {
                this.selectedComponent = c;
            } else {
                this.selectedComponent = "Report";
            }
            this.search = {
                name: e.label,
                call: e.id,
            };
        },
        async toggle_favourite(n) {

            if (n.favourite == 1) {
                n.favourite = 0
            } else {
                n.favourite = 1
            }

            let variables = {
                rows: [
                    {
                        id: this.user.id,
                        favourites: JSON.stringify(this.reports.items.filter(r => r.favourite == 1))
                    }
                ]
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation setup_users_save(
                            $rows: [setup_users_input]
                        ) {
                            setup_users_save(rows: $rows) {
                                id
                                favourites
                            }
                        }
                    `,
                    variables,
                });


            } catch (error) {
                console.log(error);
            }

            this.$store.dispatch("currentuser");

            // await this.load()

        }
    }
}
</script>

<style></style>